<div class="d-flex mt-2" [class.pattern-mini]="vitamuiMiniMode">
  <vitamui-select
    #select
    class="w-50 mr-2"
    [formControl]="control"
    [placeholder]="'SHARED.PATTERN' | translate"
    [options]="availableOptions"
    [multiple]="false"
    [enableSearch]="false"
  ></vitamui-select>

  <button class="btn primary btn-circle mt-2" [class.btn-small]="vitamuiMiniMode" (click)="add()" [disabled]="!controlValueValid()">
    <i class="vitamui-icon vitamui-icon-add"></i>
  </button>
</div>

<div class="mt-3 vitamui-chip-list">
  @for (pattern of patterns; track pattern) {
    <div class="vitamui-chip">
      <div class="vitamui-chip-content">{{ pattern }}</div>
      <div class="vitamui-remove-chip" (click)="remove(pattern)">
        <i class="material-icons">clear</i>
      </div>
    </div>
  }
</div>
